import { Typography } from '@hmsexp/component-library';
import React, { forwardRef, useImperativeHandle, useRef } from 'react';
import HighchartsReact from 'highcharts-react-official';
import Highcharts, { offset } from 'highcharts';
import Table from '../../../../../../components/Common/Table';
import { View } from '../../../../../../components/Common/react-native-components';
import { topBottomMetrixStyling } from './style';
import get from 'lodash/get';
import GraphTable from '../../../../../../components/Common/GraphTable';
import { useTransformTopAndBottomChartData } from '../../../../hooks/useTransformTopAndBottomChartData';
import {
  convertCstDataIntoBarChartCompatible,
  convertCstDataIntoTableCompatibleTest,
  getMonthWithValues
} from '../../../../../../utils/transformChartsAndTableData';
import GenericNoData from '../../../../../../components/Common/NoData/GenricNoData';
import { handleHighChartsExport } from '../../../../utils';
const TopBottomProperties = forwardRef((props, ref) => {
  const { type, itemData, lowSampleSize } = props;
  const styles = topBottomMetrixStyling();
  const selectedMetrix = 'Online Review Score';

  const options = get(itemData, 'data.chart_data');
  const chartOptions = useTransformTopAndBottomChartData(options);
  const allowedClumns = ['rank', 'property', 'No of records', 'Total', 'Benchmark', 'Delta'];

  const chartRef = useRef(null);

  const actionButtonClick = e => {
    handleHighChartsExport(e, chartRef, itemData);
  };
  useImperativeHandle(ref, () => ({ actionButtonClick }));

  const chart_options = {
    credits: {
      enabled: false
    },
    title: {
      text: ''
    },
    legend: {
      enabled: false
    },
    exporting: {
      enabled: false
    },
    chart: {
      width: 900,
      height: 400
    },
    xAxis: {
      categories: [],
      title: {
        text: ''
      }
    },
    yAxis: {
      title: {
        text: ''
      },
      min: 0
    },
    series: [
      {
        name: '',
        data: []
      }
    ],
    plotOptions: {
      series: {
        color: '#00008B'
      }
    }
  };
  if (!itemData?.cstData || !itemData?.cstData?.metric_data?.length) {
    return <GenericNoData />;
  }
  const tableData = convertCstDataIntoTableCompatibleTest(itemData?.cstData || {}, allowedClumns);
  const graphTableData = convertCstDataIntoTableCompatibleTest(itemData?.cstData || {});
  const barChartData = convertCstDataIntoBarChartCompatible(itemData?.cstData || {}, chartOptions);

  const color = get(options, 'series[0].color');

  function renderContent() {
    switch (type) {
      case 'BAR':
        return (
          <>
            <View style={{ height: 300 }}>
              <HighchartsReact ref={chartRef} highcharts={Highcharts} options={barChartData} />
            </View>
            <View style={{ flexDirection: 'row', justifyContent: 'flex-end', marginTop: 20 }}>
              <View style={[styles.selectedMetrixContainer, { borderColor: color }]}>
                <View style={{ width: 10, height: 10, backgroundColor: color }}></View>
                <Typography fontWeightType='regular' variant='button'>
                  {selectedMetrix}
                </Typography>
              </View>
            </View>
          </>
        );
      case 'TIME':
        const finalData = {
          ...graphTableData,
          table_rows: graphTableData?.table_rows?.map(row => {
            const monthData = getMonthWithValues(row);
            console.log(row)
            const options = {
              ...chart_options,
              xAxis: {
                ...chart_options.xAxis,
                categories: monthData.months
              },
              series: chart_options.series.map((s, i) => ({
                ...s,
                data: i === 0 ? monthData.data : s.data
              }))
            };


            return {
              ...row,
              nested_rows: [
                {
                  [graphTableData?.table_columns?.[0]?.field]: {
                    chart_options: options
                  }
                }
              ]
            };
          })
        };
        console.log(finalData)
        return <GraphTable lowSampleSize={lowSampleSize} graph_table_data={{ table_data: finalData }} />;

      case 'TABLE':
        return (
          <View style={{ height: 'auto' }}>
            <Table lowSampleSize={lowSampleSize} table_data={tableData} />
          </View>
        );
      default:
        break;
    }
  }

  return renderContent();
});

export default TopBottomProperties;
